import { useContext } from 'react'
import ApplicationContext from 'contexts/application-context'
import ApplicationLayout from 'Layouts/Application'
import FilterBar from 'components/FilterBar'
import PageTitle from 'components/_utils/PageTitle'
import { UserInfo, UserCard } from 'components/User'
import Button from 'components/Buttons'
import Tip from 'components/Tip'
import UserInfoState from 'components/User/UserInfo/UserInfoState'

import {
  Content,
  List,
  Items
} from './Styles'
import { IPublicStruct } from 'interfaces/IPublicStruct'
import { observer } from 'mobx-react-lite'

function ApplicationMainPage() {

  const ApplicationCtx = useContext(ApplicationContext)
  const UserData: IPublicStruct = {
    user: {
      name: 'Butterbean',
      location: 'New York, USA',
      avatar: {
        src: 'https://theprime.gg/favicon.ico',
        size: 'middle'
      },
      languages: ["uk", "pl"]
    },
    info: [{
      title: 'K/D',
      description: <Tip />
    }, {
      title: 'Main role',
      description: 'Lurker'
    }, {
      title: 'Best agent',
      description: 'Jett'
    }, {
      title: 'Rank',
      description: 'Diamond 2'
    }]
  }

  // const UserData: IPublicStruct = {
  //   user: {
  //     name: 'Butterbean',
  //     location: 'New York, USA',
  //     avatar: {
  //       src: 'https://theprime.gg/favicon.ico',
  //       size: 'middle'
  //     },
  //     languages: ["uk", "pl"]
  //   },
  //   info: [{
  //     title: 'Main role',
  //     description: 'Lurker'
  //   }, {
  //     title: 'Best agent',
  //     description: 'Jett'
  //   }, {
  //     title: 'Rank',
  //     description: 'Diamond 2'
  //   }]
  // }

  return (
    <ApplicationLayout>
      <Content>
        <FilterBar />
        <Items className={UserInfoState.isOpen ? 'open' : ''}>
          <List>
            <PageTitle>Gamers for you</PageTitle>
            <UserCard fill="solid" data={UserData} />
            <UserCard fill="solid" data={UserData} />
            <UserCard fill="solid" data={UserData} />
            <UserCard fill="solid" data={UserData} />
            <UserCard fill="solid" data={UserData} />
            <UserCard fill="solid" data={UserData} />
            <UserCard fill="solid" data={UserData} />
            {/* <UserCard fill="solid" data={UserData} buttons={[<Button variable="solid" height="small">X</Button>]} /> */}
          </List>
          <UserInfo data={UserData} />
        </Items>
      </Content>
    </ApplicationLayout>
  )
}

export default observer(ApplicationMainPage)